import { categories } from "@/mocks/categories";

export function getCategoryBySlug(slug: string) {
  return categories.find((c) => c.slug === slug);
}

export function getCategoryName(slug: string) {
  const found = categories.find((c) => c.slug === slug);
  return found ? found.name : "综合";
}

export function formatDuration(seconds: number) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function formatViews(count: number) {
  if (count >= 100000000) return `${(count / 100000000).toFixed(1)}亿`;
  if (count >= 10000) return `${(count / 10000).toFixed(1)}万`;
  return `${count}`;
}

export function formatDate(iso: string) {
  const [y, m, d] = iso.split("-");
  return `${y}年${Number(m)}月${Number(d)}日`;
}

export function timeAgo(iso: string, base = "2026-10-13") {
  const diffDays = Math.round(
    (new Date(base).getTime() - new Date(iso).getTime()) / 86400000,
  );
  if (diffDays <= 0) return "今天";
  if (diffDays === 1) return "昨天";
  if (diffDays < 7) return `${diffDays}天前`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}周前`;
  return `${Math.floor(diffDays / 30)}个月前`;
}

export function durationBucket(seconds: number) {
  if (seconds < 60) return "under1";
  if (seconds <= 300) return "1to5";
  return "over5";
}